import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import Hero from './components/Hero';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryGrid from './components/CategoryGrid';
import LatestArticles from './components/LatestArticles';

export default function Home() {
  const { t } = useTranslation();

  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '萌之社 MoeLab',
        url: 'https://mangast.github.io',
        description: '专注于二次元loli文化与萌系美学研究的专业平台',
      },
      {
        '@type': 'WebSite',
        name: '萌之社 MoeLab',
        url: 'https://mangast.github.io',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://mangast.github.io/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        name: t('seo.home.title'),
        description: t('seo.home.description'),
        url: 'https://mangast.github.io',
        isPartOf: { '@id': 'https://mangast.github.io/#website' },
      },
    ],
  };

  return (
    <SEO
      title={t('seo.home.title')}
      description={t('seo.home.description')}
      keywords={t('seo.home.keywords')}
      canonicalUrl="https://mangast.github.io"
    >
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <div className="min-h-screen bg-background-50">
        <Navbar dark />
        <main>
          <Hero />
          <FeaturedArticles />
          <CategoryGrid />
          <LatestArticles />
        </main>
        <Footer />
      </div>
    </SEO>
  );
}